import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog'
import ExaminationRoomPage from '@/pages/examinationRoom/page'

interface ExaminationRoomDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  clinicId: number
  examinationRoomId?: number
  onMutate?: () => void
}

export function ExaminationRoomDialog({
  open,
  onOpenChange,
  clinicId,
  examinationRoomId,
  onMutate,
}: ExaminationRoomDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[90vw] h-[90vh] max-w-[90vw] max-h-[90vh] p-0 overflow-hidden flex flex-col">
        <DialogTitle className="sr-only">診間設定</DialogTitle>
        <DialogDescription className="sr-only">
          在這裡管理診間的基本資訊與相關設定
        </DialogDescription>
        <ExaminationRoomPage
          clinicId={clinicId}
          examinationRoomId={examinationRoomId}
          onOpenChange={onOpenChange}
          onMutate={onMutate}
        />
      </DialogContent>
    </Dialog>
  )
}
